import { render } from "./ReportGeneralLedgerTotals.vue?vue&type=template&id=b682f1de&scoped=true"
import script from "./ReportGeneralLedgerTotals.vue?vue&type=script&lang=js"
export * from "./ReportGeneralLedgerTotals.vue?vue&type=script&lang=js"

import "./ReportGeneralLedgerTotals.vue?vue&type=style&index=0&id=b682f1de&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b682f1de"]])

export default __exports__